import type { FC } from "react";
import { UploadFileType } from "./file-upload";
import { useCreateAssetCallback } from "./hooks/use-upsert-asset";
import type { Asset } from "./server/digital-asset-service";
import { UploadFileModal } from "./upload-file-modal";

export const UploadNewFileModal: FC<{
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  onCancel: () => void;
  onChange: () => void;
  onViewFileClick: (asset: Asset) => void;
  videoUploads: boolean;
}> = ({ videoUploads, ...props }) => {
  const createAsset = useCreateAssetCallback();
  const allowedFileTypes: (keyof typeof UploadFileType)[] = videoUploads
    ? ["image", "video", "pdf"]
    : ["image", "pdf"];

  return (
    <UploadFileModal
      heading="Upload file"
      onSave={createAsset}
      allowedFileTypes={allowedFileTypes}
      {...props}
    />
  );
};
